export default __webpack_public_path__ + "static/media/img1.74f66e27.png";